import { render, staticRenderFns } from "./DocumentTemplatesCrud.vue?vue&type=template&id=34e33997&"
import script from "./DocumentTemplatesCrud.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplatesCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports